import { useState, useEffect } from "react";

interface Breadcrumb {
    name: string;
    path: string;
    isLink: boolean;
}

const useBreadcrumbs = (pathname: string, routes: any): Breadcrumb[] => {
    const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([]);

    useEffect(() => {
        const pathnames = pathname.split("/").filter((x) => x);
        const newBreadcrumbs: Breadcrumb[] = [
            {
                name: "Home",
                path: routes.HOME,
                isLink: true,
            },
        ];

        let accumulatedPath = "";

        pathnames.forEach((segment, index) => {
            accumulatedPath += `/${segment}`;
            const matchedRoute = findRouteKey(accumulatedPath, routes);
            
            let name = matchedRoute ? formatRouteName(matchedRoute) : segment;
            
            // Se for "novo" e for precedido por uma entidade, mantém a entidade e adiciona "Novo"
            if (segment === "novo" && index > 0) {
                name = "Novo";
            } 
            // Se for "edit" e for precedido por um ID numérico, mantém "Editar" sem o ID
            else if (segment === "edit" && index > 0 && pathnames[index - 1].match(/^\d+$/)) {
                name = "Editar";
                newBreadcrumbs.pop(); // Remove o ID numérico
            }
            
            newBreadcrumbs.push({
                name,
                path: accumulatedPath,
                isLink: index !== pathnames.length - 1,
            });
        });

        setBreadcrumbs(newBreadcrumbs);
    }, [pathname, routes]);

    return breadcrumbs;
};

const findRouteKey = (path: string, routes: any): string | undefined => {
    for (const key in routes) {
        const route = routes[key];
        if (typeof route === "string" && route === path) {
            return key;
        } else if (typeof route === "object") {
            const nestedKey = findRouteKey(path, route);
            if (nestedKey) {
                return `${key}.${nestedKey}`;
            }
        }
    }
    return undefined;
};

const formatRouteName = (routeKey: string): string => {
    const parts = routeKey
        .split(".")
        .map((part) =>
            part
                .replace(/_/g, " ")
                .toLowerCase()
                .replace(/^\w/, (char) => char.toUpperCase())
        );
    return parts.join(" / ");
};

export default useBreadcrumbs;